export const Masks = {
  ZIP_CODE: [/\d/, /\d/, '-', /\d/, /\d/, /\d/],
  NIP: /^\d{0,10}$/,
  DIGITS: [/\d/],
  CURRENCY_FORMAT: /^[1-9]\d*[.|,]?\d{0,2}$|^0[.|,]\d{0,2}$/,
  PREVENT_NOW_ALLOWED_CHARACTERS: /^[^!@#$%^&*(),?:{}|<>=+_]+$/,
  PHONE: [
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
  ],
};
